import React, { PropsWithChildren } from "react";
import { ChartContextFilter, ChartContextState, ChartSelection } from "models/propTypes/chartProps";
import { ContextConstants } from "utils/constants";
import { ChartReducer } from "./reducer";
import { ChartEnums } from "models/enums";

const initialState: ChartContextState = {
  type: ChartEnums.DisplayType.Periodically,
  filter: { frequency: ChartEnums.ChartDataFrequency.Monthly },
  setChartType: () => {},
  setChartFilter: () => {},
  selectedChartId: null,
  setSelectedChartId: () => {},
};

export const ChartContext = React.createContext<ChartContextState | undefined>(undefined);

const ChartContextProvider: React.FC<PropsWithChildren> = (props) => {
  const [state, dispatch] = React.useReducer(ChartReducer, initialState);
  const [selectedChartId, setSelectedChartId] = React.useState<string | null>(null);
  const [selections, setSelections] = React.useState<Record<string, ChartSelection | null>>({});

  const setChartType = (value: ChartEnums.DisplayType) => {
    if (value !== state.type) {
      dispatch({ type: ContextConstants.ChartActions.SET_CHART_TYPE, payload: value });
    }
  };

  const setChartFilter = (value: ChartContextFilter) => {
    dispatch({ type: ContextConstants.ChartActions.SET_CHART_FILTER, payload: value });
  };

  const getSelection = (chartId: string): ChartSelection | null => {
    return selections.hasOwnProperty(chartId) ? (selections[chartId] ?? null) : null;
  };

  const setSelection = (chartId: string, selection: ChartSelection | null) => {
    setSelections((prev) => {
      if (selection == null) {
        const { [chartId]: _, ...rest } = prev;
        return rest;
      }
      return { ...prev, [chartId]: selection };
    });
  };

  const clearAllSelections = () => {
    setSelections({});
  };
  return (
    <ChartContext.Provider
      value={{
        ...state,
        setChartType,
        setChartFilter,
        selectedChartId,
        setSelectedChartId,
        getSelection,
        setSelection,
        clearAllSelections,
      }}
    >
      {props.children}
    </ChartContext.Provider>
  );
};

export default ChartContextProvider;
